import api from 'Application/api/api';

const deleteStep = (signal, id) =>
	api.delete(`/step-templates/${id}`, {
		signal,
	});

export default deleteStep;
